import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'city-tax-landing-footer',
  templateUrl: './landing-footer.component.html',
  styleUrls: ['./landing-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingFooterComponent implements OnInit {
  @Input() public config$: any;

  public processingFee = '3.0%';
  public feeMinimum = '$1.95';

  constructor(
    private cd: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.config$?.subscribe((config: any) => {
      if (config) {

        console.log('config', config);

        const processingFee = config.processingFee || 0.03;
        const feeMinimum = config.feeMinimum || 1.95;

        this.processingFee = (processingFee * 100).toFixed(1) + '%';
        this.feeMinimum = `$${feeMinimum.toFixed(2)}`;

        this.cd.detectChanges();
      }
    });
  }

}
